import { FC, ReactNode, useEffect, useState } from 'react'
import { useFormId, useFormFieldError } from 'roadie-ui'

const HiddenUnlessFieldError: FC<{ name: string; value?: string; children: ReactNode }> = (props) => {
  const { name, value } = props
  const formId = useFormId()
  const id = `${formId}-${name}`
  const { error } = useFormFieldError(name)
  const [hidden, setHidden] = useState(!!value && !error)
  useEffect(() => {
    if (value && error) {
      setHidden(false) // We never want to set to hidden again once shown.
    }
  }, [value, error])
  if (hidden) {
    return <input type="hidden" id={id} name={name} value={value} />
  } else {
    return <>{props.children}</>
  }
}

export default HiddenUnlessFieldError
